import PrivilegeBadge from "./PrivilegeBadge";
export default PrivilegeBadge;